import { useEffect, useRef, useState } from 'react'
import CurrencyInput from 'react-currency-input-field'

import classes from './InputBoxCurrency.module.css'
import { useCanEditArchived, useUserTabEditPermissionDisabled } from '../../../lib/usersPermissions'
import RemoveDataConfirmationModal from '../RemoveDataConfirmationModal'


export default function InputBoxCurrency({label, name, placeholder, currentValue, action, identifier, isNotModifiable, fullBox, maxValue, fixWidth, textRight, redBorderFlag, hasValueBackground, setStyle, hasColorWhite, hasFieldAppearance, apiDisabled, showApiLoader}) {
    // let masterDisable = useCanEdit()
    let editArchivedDisabled = useCanEditArchived()
    let userPermissionDisabled = useUserTabEditPermissionDisabled(identifier?.permissionType ? identifier?.permissionType : identifier?.type) 

    const [isfocused, setIsFocused] = useState(false)
    const [value, setValue] = useState(currentValue)
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
    const didCutShortcutRef = useRef(false)

    function normalizeCurrencyValue(v) {
        if (v == null || `${v}`.trim() === '') return null
        const cleaned = `${v}`.replace(/[^0-9.-]/g, '')
        if (cleaned === '' || cleaned === '-' || cleaned === '.') return null
        const n = Number(cleaned)
        return Number.isFinite(n) ? n : null
    }

    function onChange(value) {          
        if (!userPermissionDisabled) { // check for user permission first
            if (!maxValue) {
                setValue(value)
            } else {
                if (value > maxValue) {
                    setValue(maxValue)
                } else {
                    setValue(value)
                }
            }
        } 
        
    }

    function onBlur(e) {
        if (!userPermissionDisabled) { // check for user permission first
            const hadSavedValue = currentValue != null && `${currentValue}` !== ''
            const didCutToEmpty = didCutShortcutRef.current && `${value ?? ''}` === ''
            didCutShortcutRef.current = false

            // If Ctrl/Cmd+X resulted in an empty value, treat it as a clear action that must be confirmed.
            if (didCutToEmpty && hadSavedValue) {
                setValue(currentValue)
                setIsFocused(true)
                setOpenConfirmationModal(true)
                return
            }

            if (value == '') {
                setIsFocused(false)
            }    
            
            const nextNorm = normalizeCurrencyValue(value)
            const currNorm = normalizeCurrencyValue(currentValue)
            if (action && nextNorm !== currNorm) {
                action({
                    data: {
                        value: value ? value : null
                    },
                    identifier: identifier
                })
            }
        } 
        
    }

    const handleKeyDown = (event) => {
        if ((event.ctrlKey || event.metaKey) && `${event.key}`.toLowerCase() === 'x') {
            didCutShortcutRef.current = true
        }
    }

    const foucsHandler = () => {
        if (!userPermissionDisabled) { // check for user permission first
            setIsFocused(true)
        }         
    }

    function closeConfirmationModal() {
        setOpenConfirmationModal(false)
    }

    function removeSelection() {
        if (!userPermissionDisabled) { // check for user permission first
            setValue('')
            setIsFocused(false)
            if (action) {
                action({
                    data: { value: null },
                    identifier: identifier
                })
            }
        }
        setOpenConfirmationModal(false)
    }
    
    useEffect(() => {  
        if (currentValue || typeof(currentValue) == "number") {
            setValue(currentValue)
            setIsFocused(true)
        }
    }, [currentValue])


    const isDisabled = Boolean(apiDisabled || isNotModifiable || editArchivedDisabled || userPermissionDisabled)

    return <div className={`${classes.input_container} ${setStyle ? classes[setStyle] : ''} ${textRight ? classes.input_container_right : ''} ${fullBox ? classes.input_container_full : ''} ${(isfocused && label) ? classes.is_focused : ''} ${redBorderFlag ? classes.has_red_border : ''} ${hasColorWhite ? classes.has_color_white : ''} ${hasFieldAppearance ? classes.has_field_appearance : ''} ${hasValueBackground ? classes.has_value_background: ''} ${isDisabled ? classes.is_disabled : ''}`} style={{width: fixWidth? fixWidth : ''}}>
        {label && <label htmlFor={identifier.field + '_' + identifier.type_id} className={`${classes.label} ${isfocused ? classes.is_focused : ''}`}>{label}{showApiLoader && apiDisabled ? <span className="loader dark field_label_loader" /> : null}</label>}
        <CurrencyInput
            id={identifier.field + '_' + identifier.type_id}
            name={name}
            placeholder={placeholder}
            // defaultValue={currentValue}
            value={value}
            decimalsLimit={2}
            onValueChange={onChange}
            prefix='$'
            onBlur={onBlur}
            onFocus={foucsHandler}
            onKeyDown={handleKeyDown}
            className={classes.input}
            disabled={isDisabled}
            autoComplete='off'
            />
        {openConfirmationModal && (
            <RemoveDataConfirmationModal closeModal={closeConfirmationModal} removeData={removeSelection} />
        )}
    </div>
}